import { Link } from 'react-router-dom';
import { useThemeContext } from './ThemeProvider';
import { useI18n } from '../i18n/useI18n';
import KaraokrLogo from './KaraokrLogo';

export function LandingNav() {
  const { resolvedTheme, toggleTheme } = useThemeContext();
  const { t } = useI18n();
  const nextModeLabel = resolvedTheme === 'dark' ? t('common.light') : t('common.dark');

  return (
    <nav className="landing-nav">
      <Link to="/" className="landing-nav__logo">
        <KaraokrLogo height={36} />
      </Link>
      <div className="landing-nav__links">
        <Link to="/join-room" className="landing-nav__link">{t('common.joinRoom')}</Link>
        <Link to="/festival" className="landing-nav__link">{t('nav.festival')}</Link>
        <Link to="/venues" className="landing-nav__link">{t('common.venues')}</Link>
        <button
          type="button"
          className="landing-nav__theme-btn"
          onClick={toggleTheme}
          aria-label={t('nav.themeToggle', { mode: nextModeLabel })}
          title={t('nav.themeToggle', { mode: nextModeLabel })}
        >
          {resolvedTheme === 'dark' ? (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
            </svg>
          )}
        </button>
        <Link to="/create-room" className="landing-nav__cta">{t('common.createRoom')}</Link>
      </div>
    </nav>
  );
}
